import React, { useMemo } from "react";
import TextFiledWithLabel from "./TextFieldWithLabel";
import { isValidEmail } from "../Utility/apiHelper";
import { handleValidateCodevalue } from "../Utility/constant";
import { useSelector } from "react-redux";

const CommonEmail = ({name , isDetailPage,isViewMode,label,value = "",handleOnChange,isRequired = false,...otherProps}) => {
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);

  
  //To show error if input is inValid.
 const isInvalid = useMemo(() => {
  if (!value) return isRequired;
  return !isValidEmail(value);
}, [value, isRequired]);

  return (
    <TextFiledWithLabel
      name = {name}
      isViewMode={isViewMode}
      label={label || handleValidateCodevalue(internationalise, 'COMMON_EMAIL_ID')}
      value={value}
      handleOnChange={handleOnChange}
      inputProps={{
        maxLength: 100,
        inputMode: "email",
      }}
      error={isDetailPage && isInvalid}
      helperText={(isDetailPage && isInvalid) ?handleValidateCodevalue(internationalise, 'COMMON_MSG_VALID_EMAIL') : undefined}
      {...otherProps}
    />
  );
};

export default CommonEmail;
